import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';

import Home from './pages/home.js';
import About from './pages/about.js';
import Contact from './pages/contact.js';

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

import "@fontsource/dancing-script";

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const navItems = [
    { text: 'Home', path: '/', element: <Home/> },
    { text: 'About', path: '/about', element: <About/>},
    { text: 'Contact', path: '/contact', element: <Contact/> },
  ];

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <Router>
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
        <AppBar position="static">
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={toggleMenu}
              sx={{ mr: 2 }}
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }} fontFamily="Dancing Script">
              Pelter Family
            </Typography>
          </Toolbar>

          {/* Collapsible Nav Menu */}
          <Collapse in={menuOpen} timeout="auto" unmountOnExit>
          <Box
            sx={{
              backgroundColor: '#cccaca',
              color: '#000',
              px: 2,
              py: 1,
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              gap: 1,
              overflowX: 'hidden',
            }}
          >
            {navItems.map((item) => (
              <Box
                key={item.text}
                component={Link}
                to={item.path}
                onClick={() => setMenuOpen(false)}
                sx={{
                  backgroundColor: '#e0e0e0',
                  borderRadius: 2,
                  px: 2,
                  py: 1,
                  textAlign: 'center',
                  textDecoration: 'none',
                  color: 'inherit',
                  width: isMobile ? '90%' : 'auto',
                  display: 'block',
                  fontWeight: 'bold',
                  boxShadow: 1,
                  transition: 'background-color 0.2s ease, box-shadow 0.2s ease',
                  '&:hover': {
                    backgroundColor: '#d5d5d5',
                    boxShadow: 2,
                  },
                  '&:active': {
                    backgroundColor: '#cfcfcf',
                    boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.2)',
                  },
                }}
              >
                {item.text}
              </Box>
            ))}
          </Box>
          </Collapse>
        </AppBar>

        <Box component="main" sx={{ flexGrow: 1, p: 3, backgroundColor: '#8a8a8a' }}>
          <Routes>
            {navItems.map((item) => (
              <Route path={item.path} element={item.element} />
            ))}
          </Routes>
        </Box>
      </Box>
    </Router>
  );
}

export default App;
